import Axios from "axios";

export default function getStudentSavedPriority(std_id){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'getStudentSavedPriority',
            std_id
        }
    });
    return response;
}